<h3>Factoring</h3>

<DataGridView [DataUrl]="dataurl()" #Grid KeyProperty="key">
  <DataGridViewColumn field="key" header="DCO-ID" [DataType]="Types.Number" />
  <DataGridViewColumn field="firstName" header="Vorname"[DataType]="Types.String" />
  <DataGridViewColumn field="lastName" header="Nachname" [DataType]="Types.String" />
  <DataGridViewColumn field="leistungserbringer" header="Leistungserbringer" [DataType]="Types.String" />
  <DataGridViewColumn field="status" header="Status" [DataType]="Types.Number" />
  <DataGridViewColumn field="tracking" header="DHL Tracking" [DataType]="Types.String" />
  <DataGridViewColumn field="created" header="Erstellt Am" [DataType]="Types.Date" formart="dd.MM.yyyy"  />
  <DataGridViewColumn field="inbetriebnahmedatum" header="Inbetriebnahmedatum" [DataType]="Types.Date" formart="dd.MM.yyyy"  />
  <DataGridViewColumn field="versand" header="Versand" [DataType]="Types.Date" formart="dd.MM.yyyy"  />
</DataGridView>

